



import { Component, Vue } from 'vue-property-decorator';

import Tooltip from '@/shared/components/Tooltip.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

@Component({
  components: {
      Tooltip,
      Icon,
  },
})

export default class TooltipPartial extends Vue {

  private iconEnum = IconEnum;

}
